import { render } from "./Recuruiment.vue?vue&type=template&id=675b2adc&scoped=true"
import script from "./Recuruiment.vue?vue&type=script&lang=js"
export * from "./Recuruiment.vue?vue&type=script&lang=js"

import "./Recuruiment.vue?vue&type=style&index=0&id=675b2adc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b2adc"]])

export default __exports__